<template>
    <ul class="list-reset">
        <database-filter-search-item
                v-for="item in tree.root"
                :model="item"
                :key="item.id"
                :search="search"
                :codes="codes"
                :folder-select="false"
        ></database-filter-search-item>
    </ul>
</template>

<script>

    import DatabaseFilterSearchItem from "./FilterSearchItem";

    export default {

        props: ['search', 'codes'],

        components: {DatabaseFilterSearchItem},

        inject: ['tree'],

    }

</script>